import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "item", "empty"]

  filter() {
    const query = this.inputTarget.value.toLowerCase()
    let visibleCount = 0

    this.itemTargets.forEach(item => {
      const match = item.dataset.search.includes(query)
      item.classList.toggle("hidden", !match)
      if (match) visibleCount++
    })

    if (this.hasEmptyTarget) {
      this.emptyTarget.classList.toggle("hidden", visibleCount > 0)
    }
  }
}
